<div style="position: relative">
    <ngx-spinner [fullScreen]="false" name="custom-pdf-viewer"></ngx-spinner>
    <ngx-extended-pdf-viewer
        [src]="src"
        useBrowserLocale="true"
        height="75vh"
        (pdfLoadingFailed)="onError($event)"
        [showUnverifiedSignatures]="true"></ngx-extended-pdf-viewer>
    <div *ngIf="pdf_error">
        <div class="row">
            <div class="col">
                <div class="alert" [ngClass]="err_msg.alert_class">
                    <span class="d-flex justify-content-center">{{
                        err_msg.text
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
